import React from "react";
import { useNavigation } from "@react-navigation/native";
import { useTranslations } from "@src/packages/i18n";
import { useExposure } from "../ExposureContext";
import type { ExposureStackScreenProps } from "../ExposureNavigator";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@louise/medical-history/components/BaseCompleteScreen";

export function ExposureCompleteScreen() {
  const t = useTranslations();
  const navigation =
    useNavigation<ExposureStackScreenProps<"ExposureComplete">["navigation"]>();
  const { state, submit, isSubmitting } = useExposure({
    name: "ExposureComplete",
  });

  const handleFinish = async () => {
    try {
      await submit(state);
      navigateToNextSection(navigation, "exposure");
    } catch {}
  };

  return (
    <BaseCompleteScreen
      subtitle={t("med_history.lifestyle.exposure.complete_subtitle")}
      buttonLabel={getNextSectionButtonLabel(t, "exposure")}
      isSubmitting={isSubmitting}
      onFinish={handleFinish}
    />
  );
}

export default ExposureCompleteScreen;
